<div class="modal-header">
  <h4 class="modal-title">{{ pageTitle }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body client_info">
  <div *ngIf="!businessAcc.id">
    <br />
    <h6 [translate]="'GENERAL.GETTING_RECORDS'"
      ><i class="fas fa-spinner fa-spin"></i> Getting records...</h6
    >
    <br />
  </div>
  <div *ngIf="businessAcc.id">
    <div class="form-group">
      <small class="label" [translate]="'ACCOUNT.BUSINESS_NAME'"
        >Business Name</small
      >
      <span class="value">{{ businessAcc.business_name }}</span>
    </div>
    <div class="form-group">
      <small class="label" [translate]="'ACCOUNT.BUSINESS_TYPE'"
        >Business Type</small
      >
      <span class="value">{{ businessAcc.business_type }}</span>
    </div>
    <div class="form-group">
      <small class="label" [translate]="'ADDRESS.BUSINESS_ADDRESS'"
        >Business Address</small
      >
      <span class="value">{{ businessAcc.business_address }}</span>
    </div>
    <div class="form-group">
      <small class="label" [translate]="'ADDRESS.CITY_ADDRESS'"
        >Business City</small
      >
      <span class="value">{{ businessAcc.business_city }}</span>
    </div>
    <div class="form-group">
      <small class="label" [translate]="'ADDRESS.STATE_ADDRESS'"
        >Business State</small
      >
      <span class="value">{{ businessAcc.business_state }}</span>
    </div>
    <div class="form-group">
      <small class="label" [translate]="'ADDRESS.ZIP_CODE'">Business Zip</small>
      <span class="value">{{ businessAcc.business_zip }}</span>
    </div>
    <div class="form-group">
      <small class="label" [translate]="'ADDRESS.COUNTRY'">Business Country</small>
      <span class="value">{{ businessAcc.business_country }}</span>
    </div>
    <div class="form-group">
      <small class="label" [translate]="'CONTACT.PHONE'">Business Phone</small>
      <span class="value">{{ businessAcc.phone }}</span>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-danger"
    (click)="activeModal.dismiss('')"
    [translate]="'BUTTONS.CLOSE'"
  >
    <i class="fas fa-times"></i> Close
  </button>
</div>
